import { render, staticRenderFns } from "./Automotriz.vue?vue&type=template&id=40e53ebd"
import script from "./Automotriz.vue?vue&type=script&lang=js"
export * from "./Automotriz.vue?vue&type=script&lang=js"
import style0 from "./Automotriz.vue?vue&type=style&index=0&id=40e53ebd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports